import * as THREE from 'https://unpkg.com/three@0.161.0/build/three.module.js';

const A = (p) => (window.FND_ASSETS && window.FND_ASSETS[p.split('/').pop()]) || p;
function canvasTex(draw, w = 256, h = 256, repX = 6, repY = 1) {
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  draw(c.getContext('2d'), w, h);
  const t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(repX, repY);
  t.colorSpace = THREE.SRGBColorSpace;
  return t;
}
const PHOTOS = {
  meteorite: ['assets/tex-meteorite.png', 3, 1, true],
  antler: ['assets/tex-antler.png', 3, 1, true],
  oak: ['assets/tex-oak.png', 6, 1, true],
  redopal: ['assets/tex-redopal.png', 4, 1, true],
  cosmos: ['assets/tex-cosmos.jpg', 5, 1, true],
  crushedmet: ['assets/tex-crushedmet.png', 3, 1, true],
  sandstone: ['assets/tex-sandstone.jpg', 4, 1, true],
  blueopal: ['assets/tex-blueopal.jpg', 4, 1, true],
  abalone: ['assets/tex-abalone.png', 4, 1, true],
  greenopal: ['assets/tex-greenopal.png', 4, 1, true],
  sandphoto: ['assets/tex-sandblasted.jpeg', 4, 2, false],
  sandrelief: ['assets/tex-sandblasted-relief.png', 3, 1, true],
  hammerphoto: ['assets/tex-hammered.jpg', 6, 1, false],
  hammerrelief: ['assets/tex-hammered-relief.png', 3, 1, true],
  facetrelief: ['assets/tex-faceted-relief.png', 3, 1, true],
  facetrelief2: ['assets/tex-faceted2-relief.png', 3, 1, true],
  roughrelief: ['assets/tex-roughbrushed-relief.png', 2, 1, true],
};
const TEX = {
  meteorite: () => canvasTex((g, w, h) => {
    g.fillStyle = '#98a0aa'; g.fillRect(0, 0, w, h);
    for (let p = 0; p < 8; p++) {
      const cx = Math.random() * w, cy = Math.random() * h, n = 3 + Math.floor(Math.random() * 3);
      g.save(); g.beginPath();
      for (let k = 0; k <= n; k++) { const a = (k / n) * Math.PI * 2 + p; const r = 60 + Math.random() * 90; const x = cx + Math.cos(a) * r, y = cy + Math.sin(a) * r; k ? g.lineTo(x, y) : g.moveTo(x, y); }
      g.closePath(); g.clip();
      g.translate(cx, cy); g.rotate(Math.random() * Math.PI); g.translate(-cx, -cy);
      const sp = 5 + Math.random() * 4;
      for (let y = -h; y < h * 2; y += sp) {
        g.fillStyle = (Math.floor(y / sp) % 2) ? 'rgba(70,78,88,0.55)' : 'rgba(198,205,214,0.5)';
        g.fillRect(-w, y, w * 3, sp * (0.35 + Math.random() * 0.25));
      }
      g.restore();
    }
    for (let i = 0; i < 120; i++) { g.fillStyle = 'rgba(40,45,52,' + (0.1 + Math.random() * 0.25) + ')'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.5 + Math.random() * 1.2, 0, 7); g.fill(); }
  }, 512, 512, 3, 1),
  antler: () => canvasTex((g, w, h) => {
    g.fillStyle = '#e8e0cd'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 26; i++) { g.fillStyle = ['rgba(216,203,172,0.5)', 'rgba(242,236,224,0.6)', 'rgba(199,182,143,0.35)'][i % 3]; g.beginPath(); g.ellipse(Math.random() * w, Math.random() * h, 20 + Math.random() * 55, 10 + Math.random() * 28, Math.random() * 3, 0, 7); g.fill(); }
    for (let i = 0; i < 22; i++) {
      g.strokeStyle = 'rgba(160,138,96,' + (0.25 + Math.random() * 0.3) + ')'; g.lineWidth = 0.8 + Math.random() * 1.8; g.beginPath();
      let x = Math.random() * w, y = Math.random() * h; g.moveTo(x, y);
      for (let k = 0; k < 10; k++) { x += (Math.random() - 0.5) * 34; y += 12 + Math.random() * 16; g.quadraticCurveTo(x + (Math.random() - 0.5) * 18, y - 8, x, y); }
      g.stroke();
    }
    for (let i = 0; i < 420; i++) { g.fillStyle = 'rgba(150,130,95,' + (0.08 + Math.random() * 0.18) + ')'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.5 + Math.random() * 1.6, 0, 7); g.fill(); }
  }, 512, 512, 3, 1),
  oak: () => canvasTex((g, w, h) => {
    g.fillStyle = '#5e3f24'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 34; i++) {
      g.strokeStyle = ['rgba(58,33,15,0.7)', 'rgba(139,95,56,0.5)', 'rgba(43,23,10,0.6)', 'rgba(160,116,70,0.35)'][i % 4];
      g.lineWidth = 1 + Math.random() * 3.5; g.beginPath();
      let y = Math.random() * h; g.moveTo(0, y);
      for (let x = 0; x <= w; x += 16) { y += (Math.random() - 0.5) * 5; g.lineTo(x, y); }
      g.stroke();
    }
    for (let i = 0; i < 3; i++) {
      const kx = Math.random() * w, ky = Math.random() * h;
      for (let r = 14; r > 2; r -= 3) { g.strokeStyle = 'rgba(40,20,8,' + (0.25 + (14 - r) * 0.04) + ')'; g.lineWidth = 1.5; g.beginPath(); g.ellipse(kx, ky, r * 1.7, r, 0.3, 0, 7); g.stroke(); }
    }
    for (let i = 0; i < 160; i++) { g.fillStyle = 'rgba(26,13,5,' + (0.15 + Math.random() * 0.3) + ')'; g.fillRect(Math.random() * w, Math.random() * h, 1 + Math.random() * 4, 0.6 + Math.random() * 1.2); }
  }, 512, 512, 4, 1),
  sandstone: () => canvasTex((g, w, h) => {
    g.fillStyle = '#122250'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 500; i++) { const b = Math.random(); g.fillStyle = b > 0.85 ? '#e4ecff' : b > 0.5 ? '#8fa7e8' : '#3a5090'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.6 + Math.random() * 1.4, 0, 7); g.fill(); }
  }, 256, 256, 4, 1),
  redopal: () => canvasTex((g, w, h) => {
    g.fillStyle = '#9e2f1e'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 60; i++) { g.fillStyle = ['#c14a2e', '#7d2013', '#b03a24'][i % 3]; g.beginPath(); g.ellipse(Math.random() * w, Math.random() * h, 6 + Math.random() * 18, 4 + Math.random() * 10, Math.random() * 3, 0, 7); g.fill(); }
    for (let i = 0; i < 260; i++) { const b = Math.random(); g.fillStyle = b > 0.75 ? '#ffd9c4' : b > 0.4 ? '#ff8a5c' : '#ffb08f'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.5 + Math.random() * 1.3, 0, 7); g.fill(); }
  }, 256, 256, 4, 1),
  cosmos: () => canvasTex((g, w, h) => {
    g.fillStyle = '#171633'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 40; i++) { g.fillStyle = ['#232055', '#101024', '#2a1e4a'][i % 3]; g.beginPath(); g.ellipse(Math.random() * w, Math.random() * h, 8 + Math.random() * 22, 5 + Math.random() * 12, Math.random() * 3, 0, 7); g.fill(); }
    for (let i = 0; i < 320; i++) { const b = Math.random(); g.fillStyle = b > 0.8 ? '#ffffff' : b > 0.55 ? '#7fe0ff' : b > 0.3 ? '#b48fff' : '#5a79e8'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.4 + Math.random() * 1.2, 0, 7); g.fill(); }
  }, 256, 256, 4, 1),
  crushedmet: () => canvasTex((g, w, h) => {
    g.fillStyle = '#0f1013'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 200; i++) {
      const x = Math.random() * w, y = Math.random() * h, r = 1.5 + Math.random() * 6;
      g.fillStyle = ['#9aa2ab', '#c0c7cf', '#6f7680', '#848c96'][i % 4];
      g.save(); g.translate(x, y); g.rotate(Math.random() * Math.PI); g.beginPath();
      const n = 3 + Math.floor(Math.random() * 2);
      for (let k = 0; k <= n; k++) { const a = (k / n) * Math.PI * 2; const rr = r * (0.5 + Math.random() * 0.7); k ? g.lineTo(Math.cos(a) * rr, Math.sin(a) * rr) : g.moveTo(Math.cos(a) * rr, Math.sin(a) * rr); }
      g.closePath(); g.fill(); g.restore();
    }
    for (let i = 0; i < 90; i++) { g.fillStyle = 'rgba(230,238,246,' + (0.3 + Math.random() * 0.5) + ')'; g.beginPath(); g.arc(Math.random() * w, Math.random() * h, 0.3 + Math.random() * 0.8, 0, 7); g.fill(); }
  }, 512, 512, 4, 1),
  brushfine: () => canvasTex((g, w, h) => {
    g.fillStyle = '#8a8a8a'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 500; i++) { const y = Math.random() * h; g.strokeStyle = 'rgba(' + (Math.random() > 0.5 ? '210,210,210' : '90,90,90') + ',' + (0.06 + Math.random() * 0.12) + ')'; g.lineWidth = 0.5 + Math.random() * 0.8; g.beginPath(); g.moveTo(0, y); g.lineTo(w, y + (Math.random() - 0.5) * 2); g.stroke(); }
  }, 512, 128, 2, 1),
  brushcoarse: () => canvasTex((g, w, h) => {
    g.fillStyle = '#858585'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 180; i++) { const y = Math.random() * h; g.strokeStyle = 'rgba(' + (Math.random() > 0.5 ? '225,225,225' : '55,55,55') + ',' + (0.15 + Math.random() * 0.3) + ')'; g.lineWidth = 1 + Math.random() * 2.4; g.beginPath(); g.moveTo(0, y); g.lineTo(w, y + (Math.random() - 0.5) * 4); g.stroke(); }
  }, 512, 128, 2, 1),
};
const METALS = {
  'Tungsten': { color: 0x585d66, rough: 0.32 },
  'Titanium': { color: 0x9aa0a8, rough: 0.38 },
  'Black Zirconium': { color: 0x26272a, rough: 0.45 },
  'Scottish Deer Antler': { tex: 'antler', color: 0xffffff, rough: 0.7, organic: true },
  'Whisky Barrel Oak': { tex: 'oak', color: 0xffffff, rough: 0.65, organic: true },
};
const METAL_INLAYS = { 'Brushed Black Metal': { color: 0x1c1d20, rough: 0.52 }, 'Brushed Titanium': { color: 0x8f949b, rough: 0.45 }, 'Brushed Gold': { color: 0xc9a24b, rough: 0.45 } };
const INLAY_TEX = { 'Muonionalusta Meteorite': 'meteorite', 'Scottish Deer Antler': 'antler', 'Whisky Barrel Oak': 'oak', 'Oak': 'oak', 'Blue Sandstone': 'sandstone', 'Red Opal': 'redopal', 'Blue Opal': 'blueopal', 'Abalone': 'abalone', 'Green Opal & Abalone': 'greenopal', 'Cosmos (alexandrite & meteorite)': 'cosmos', 'Crushed Meteorite in Resin': 'crushedmet' };
const SLEEVES = { 'Titanium sleeve': { color: 0x9aa0a8, rough: 0.35 }, 'Antler sleeve': { tex: 'antler', color: 0xffffff, rough: 0.7 }, 'Oak sleeve': { tex: 'oak', color: 0xffffff, rough: 0.65 } };

class RingViewer extends HTMLElement {
  static get observedAttributes() { return ['config']; }
  set config(v) { this._cfg = typeof v === 'string' ? JSON.parse(v) : v; if (this._ready) this.build(); }
  get config() { return this._cfg; }
  attributeChangedCallback(n, o, v) { if (v) this.config = v; }
  connectedCallback() {
    if (this._ready) return;
    // config assigned before upgrade lands as an own property that shadows the setter: adopt and clear it
    if (Object.prototype.hasOwnProperty.call(this, 'config')) { const pre = this.config; delete this.config; this._cfg = typeof pre === 'string' ? JSON.parse(pre) : pre; }
    this.style.display = 'block'; this.style.width = '100%';
    if (!this.clientHeight) this.style.minHeight = '260px';
    const renderer = this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.appendChild(renderer.domElement);
    renderer.domElement.style.cssText = 'width:100%;height:100%;display:block;cursor:grab;touch-action:none';
    const scene = this.scene = new THREE.Scene();
    const cam = this.cam = new THREE.PerspectiveCamera(32, 1, 0.1, 200);
    cam.position.set(0, 8, 34); cam.lookAt(0, 0, 0);
    const env = new THREE.Scene();
    const mk = (w, h, x, y, z, c, i) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: c })); m.position.set(x, y, z); m.lookAt(0, 0, 0); m.material.color.multiplyScalar(i); env.add(m); };
    env.background = new THREE.Color(0x999999);
    mk(30, 30, 0, 20, 0, 0xffffff, 3.5); mk(25, 14, -18, 4, 10, 0xfff4e0, 2.6); mk(25, 14, 18, 2, -8, 0xdde6ff, 2.2); mk(30, 12, 0, -15, 5, 0xcccccc, 1.4); mk(20, 20, 0, 6, -20, 0xffffff, 1.8);
    const pmrem = new THREE.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(env).texture;
    pmrem.dispose();
    scene.add(new THREE.HemisphereLight(0xffffff, 0x555566, 0.9));
    const key = new THREE.DirectionalLight(0xffffff, 2.2); key.position.set(8, 14, 10); scene.add(key);
    const fill = new THREE.DirectionalLight(0xfff0dd, 0.8); fill.position.set(-10, -6, -8); scene.add(fill);
    const group = this.group = new THREE.Group(); scene.add(group);
    group.rotation.set(0.35, 0, 0);
    this.textures = {};
    let drag = null, idle = 0;
    const el = renderer.domElement;
    el.addEventListener('pointerdown', e => { drag = { x: e.clientX, y: e.clientY }; el.setPointerCapture(e.pointerId); el.style.cursor = 'grabbing'; });
    el.addEventListener('pointermove', e => { if (!drag) return; group.rotation.y += (e.clientX - drag.x) * 0.01; group.rotation.x += (e.clientY - drag.y) * 0.01; drag = { x: e.clientX, y: e.clientY }; idle = 0; });
    el.addEventListener('pointerup', () => { drag = null; el.style.cursor = 'grab'; });
    const resize = () => {
      const w = this.clientWidth || 300, h = this.clientHeight || 300;
      renderer.setSize(w, h, false); cam.aspect = w / h;
      const halfExtent = 13;
      const vFov = THREE.MathUtils.degToRad(cam.fov / 2);
      const dist = halfExtent / Math.tan(vFov) / Math.min(1, cam.aspect);
      cam.position.setLength(Math.max(dist, 26));
      cam.updateProjectionMatrix();
    };
    new ResizeObserver(resize).observe(this); resize();
    const loop = () => { this._raf = requestAnimationFrame(loop); if (!drag) { idle++; if (idle > 90) group.rotation.y += 0.004; } renderer.render(scene, cam); };
    loop();
    this._ready = true;
    if (this.getAttribute('config')) this.config = this.getAttribute('config');
    if (this._cfg) this.build();
  }
  disconnectedCallback() { cancelAnimationFrame(this._raf); }
  tex(name) {
    if (!this.textures[name]) {
      if (PHOTOS[name]) {
        const [url, rx, ry, srgb] = PHOTOS[name];
        const t = new THREE.TextureLoader().setCrossOrigin('anonymous').load(A(url), undefined, undefined, () => { if (TEX[name]) this.textures[name] = TEX[name](); });
        t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(rx, ry);
        if (srgb) t.colorSpace = THREE.SRGBColorSpace;
        this.textures[name] = t;
      } else this.textures[name] = TEX[name]();
    }
    return this.textures[name];
  }
  mat(def, extra) { const m = new THREE.MeshPhysicalMaterial({ color: def.color ?? 0xffffff, metalness: def.metal ?? 0.75, roughness: def.rough ?? 0.4, envMapIntensity: 1.5, side: THREE.DoubleSide, ...extra }); if (def.tex) { m.map = this.tex(def.tex); m.metalness = def.tex === 'carbon' ? 0.5 : 0.12; } return m; }
  build() {
    const g = this.group, c = this._cfg; if (!c) return;
    while (g.children.length) { const ch = g.children.pop(); ch.geometry?.dispose(); ch.material?.dispose(); }
    const R = 10, T = 1.25, w = c.width || 8, hw = w / 2, mm = 1;
    const court = c.profile === 'Court';
    const bevel = c.edge === 'Bevelled' ? 1.0 : 0, step = c.edge === 'Stepped edge' ? 0.45 : 0;
    const be = Math.max(bevel, step);
    const gh = 0.175;
    const grooves = [];
    if (c.groove === 'Single centre groove') grooves.push({ y: 0, half: gh });
    if (c.groove === 'Twin grooves') { const inset = c.grooveInset || 1.5; const gy = hw - be - inset; grooves.push({ y: -gy, half: gh }, { y: gy, half: gh }); }
    if (c.groove === 'Offset groove') grooves.push({ y: c.grooveFlip ? -w * 0.2 : w * 0.2, half: gh });
    const inlays = [];
    if (c.inlay) {
      const iw = c.inlayW || 2, ih = iw / 2;
      if (c.count === 'Double') { inlays.push({ y: -(ih + 0.5), half: ih, mat: c.inlay2 }, { y: ih + 0.5, half: ih }); }
      else if (c.count === 'Triple') { inlays.push({ y: 0, half: ih }, { y: -(iw + 0.5), half: ih, mat: c.inlay3 || c.inlay2 }, { y: iw + 0.5, half: ih, mat: c.inlay2 }); }
      else if (/^Offset \(/.test(c.placement || '')) { const off = parseFloat(c.placement.match(/([\d.]+)mm/)[1]); inlays.push({ y: hw - off - ih, half: ih }); }
      else inlays.push({ y: 0, half: ih });
    }
    const outerR = y => {
      let r = R + T + (court ? 0.32 * Math.cos((y / hw) * Math.PI / 2) : 0);
      for (const gr of grooves) { const d = Math.abs(y - gr.y); if (d < gr.half) r -= 0.25 * Math.cos((d / gr.half) * Math.PI / 2); }
      return r;
    };
    const pts = [];
    pts.push(new THREE.Vector2(R, -hw), new THREE.Vector2(R, hw));
    const faceLo = -hw + Math.max(bevel, step), faceHi = hw - Math.max(bevel, step);
    if (bevel) pts.push(new THREE.Vector2(outerR(faceHi) - bevel * 0.55, hw));
    else if (step) { pts.push(new THREE.Vector2(outerR(faceHi) - 0.35, hw)); pts.push(new THREE.Vector2(outerR(faceHi) - 0.35, faceHi)); }
    const N = 80;
    for (let i = 0; i <= N; i++) { const y = faceHi - (i / N) * (faceHi - faceLo); pts.push(new THREE.Vector2(outerR(y), y)); }
    if (bevel) pts.push(new THREE.Vector2(outerR(faceLo) - bevel * 0.55, -hw));
    else if (step) { pts.push(new THREE.Vector2(outerR(faceLo) - 0.35, faceLo)); pts.push(new THREE.Vector2(outerR(faceLo) - 0.35, -hw)); }
    pts.push(new THREE.Vector2(R, -hw));
    const geo = new THREE.LatheGeometry(pts, 160);
    const mdef = { ...(METALS[c.metal] || METALS.Tungsten) };
    if (c.colourHex && !mdef.organic) { mdef.color = new THREE.Color(c.colourHex).getHex(); delete mdef.tex; }
    const zirc = c.metal === 'Black Zirconium';
    if (zirc) { mdef.color = 0x26272a; mdef.rough = 0.45; }
    const RAWZ = 0x9aa0a8;
    const rough = c.finish === 'Polished' ? Math.max(zirc ? 0.3 : 0.08, (mdef.rough ?? 0.4) - 0.22)
      : c.finish === 'Hammered' ? (mdef.rough ?? 0.4) + 0.05
      : /Rough brushed/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.22
      : /Sandblasted/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.35
      : /Faceted/.test(c.finish || '') ? (mdef.rough ?? 0.4) + 0.12
      : mdef.rough;
    const bandMat = this.mat({ ...mdef, rough });
    const liftDark = (col) => {
      const cc = new THREE.Color(col);
      const lum = cc.r * 0.299 + cc.g * 0.587 + cc.b * 0.114;
      return lum < 0.16 ? { color: cc.lerp(new THREE.Color(0x9a9da3), 0.22).getHex(), env: 2.2 } : { color: cc.getHex(), env: null };
    };
    if (mdef.organic && c.wrap && c.wrap !== 'None') {
      const wcol = c.colourHex ? new THREE.Color(c.colourHex).getHex() : 0x4a4e54;
      const full = c.wrap === 'Full cover';
      const flush = c.wrap === 'Flush to one edge';
      const wh = full ? (faceHi - faceLo) / 2 - 0.02 : Math.min((c.wrapW || 3) / 2, (faceHi - faceLo) / 2 - (flush ? 0.5 : 1));
      const wy = full ? (faceLo + faceHi) / 2 : flush ? faceHi - wh - 0.02 : (faceLo + faceHi) / 2;
      const wp = []; const WM = 30;
      for (let i = 0; i <= WM; i++) { const y = wy - wh + (i / WM) * wh * 2; wp.push(new THREE.Vector2(outerR(y) + 0.06, y)); }
      const wld = liftDark(wcol);
      const wm2 = new THREE.MeshPhysicalMaterial({ color: wld.color, metalness: 0.75, envMapIntensity: wld.env || 1.3, side: THREE.DoubleSide, roughness: 0.35 });
      if (/Rough brushed/.test(c.finish || '')) { wm2.map = this.tex('roughrelief'); wm2.metalness = 0.55; wm2.roughness = wld.env ? 0.5 : 0.6; }
      else if (/Sandblasted/.test(c.finish || '')) { wm2.map = this.tex('sandrelief'); wm2.metalness = 0.25; wm2.roughness = wld.env ? 0.72 : 0.85; wm2.envMapIntensity = wld.env ? 1.1 : 0.6; }
      else if (c.finish === 'Polished') { wm2.roughness = 0.1; }
      else { const bt = this.tex('brushfine'); wm2.bumpMap = bt; wm2.bumpScale = 0.008; wm2.roughnessMap = bt; wm2.roughness = 0.7; }
      g.add(new THREE.Mesh(new THREE.LatheGeometry(wp, 160), wm2));
      if (!full) {
        const rims = flush ? [wy - wh] : [wy - wh, wy + wh];
        for (const yy of rims) {
          const rp = [new THREE.Vector2(outerR(yy) + 0.065, yy - 0.02), new THREE.Vector2(outerR(yy) + 0.065, yy + 0.02)];
          g.add(new THREE.Mesh(new THREE.LatheGeometry(rp, 160), new THREE.MeshPhysicalMaterial({ color: 0x111111, metalness: 0.8, roughness: 0.4, side: THREE.DoubleSide })));
        }
      }
    }
    const faceBase = c.zircFace ? RAWZ : mdef.color;
    const addFaceStrips = (mapName, mopts) => {
      let segs = [[faceLo + 0.03, faceHi - 0.03]];
      for (const inl of inlays) {
        const next = [];
        for (const [a, b] of segs) {
          const ca = inl.y - inl.half - 0.05, cb = inl.y + inl.half + 0.05;
          if (cb <= a || ca >= b) { next.push([a, b]); continue; }
          if (ca - a >= 0.3) next.push([a, ca]);
          if (b - cb >= 0.3) next.push([cb, b]);
        }
        segs = next;
      }
      for (const [a, b] of segs) {
        const fp = []; const FM = 40;
        for (let i = 0; i <= FM; i++) { const y = a + (i / FM) * (b - a); fp.push(new THREE.Vector2(outerR(y) + 0.02, y)); }
        const ld = liftDark(faceBase);
        const fmat = new THREE.MeshPhysicalMaterial({ map: this.tex(mapName), color: ld.color, envMapIntensity: ld.env || 1.2, side: THREE.DoubleSide, ...mopts, ...(ld.env ? { roughness: Math.max(0.3, (mopts.roughness ?? 0.5) - 0.12) } : {}) });
        g.add(new THREE.Mesh(new THREE.LatheGeometry(fp, 160), fmat));
      }
    };
    if (!mdef.organic) {
    if (/Rough brushed/.test(c.finish || '')) {
      addFaceStrips('roughrelief', { metalness: 0.55, roughness: 0.6 });
    } else if (c.finish === 'Hammered') {
      addFaceStrips('hammerrelief', { metalness: 0.5, roughness: 0.5 });
    } else if (/brushed/i.test(c.finish || '')) {
      const bt = this.tex('brushfine');
      bandMat.bumpMap = bt; bandMat.bumpScale = 0.008; bandMat.roughnessMap = bt;
      bandMat.roughness = Math.min(1, rough + 0.35);
    } else if (/Sandblasted/.test(c.finish || '')) {
      addFaceStrips('sandrelief', { metalness: 0.25, roughness: 0.85, envMapIntensity: 0.6 });
    } else if (/Faceted/.test(c.finish || '')) {
      addFaceStrips('facetrelief2', { metalness: 0.5, roughness: 0.48 });
    }
    } else if (c.finish === 'Polished') { bandMat.roughness = Math.min(bandMat.roughness, 0.35); }
    if (c.zircFace && !mdef.organic && !/Rough brushed|Hammered|Sandblasted|Faceted/.test(c.finish || '')) {
      let za = faceLo + 0.03, zb = faceHi - 0.03;
      if (c.zircFaceCover === 'Centre band') { const zh = Math.min((c.zircFaceW || 2) / 2, (faceHi - faceLo) / 2 - 0.05); const zc = (faceLo + faceHi) / 2; za = zc - zh; zb = zc + zh; }
      else if (c.zircFaceCover === 'From top edge') { za = Math.max(faceLo + 0.05, faceHi - (c.zircFaceW || 2)); }
      else if (c.zircFaceCover === 'From bottom edge') { zb = Math.min(faceHi - 0.05, faceLo + (c.zircFaceW || 2)); }
      else if (c.zircFaceCover === 'Offset (1mm from edge)') { zb = faceHi - 1; za = Math.max(faceLo + 0.05, zb - (c.zircFaceW || 2)); }
      const zp = []; const ZM = 40;
      for (let i = 0; i <= ZM; i++) { const y = za + (i / ZM) * (zb - za); zp.push(new THREE.Vector2(outerR(y) + 0.02, y)); }
      const zfm = this.mat({ color: RAWZ, rough: c.finish === 'Polished' ? 0.12 : 0.45 });
      zfm.side = THREE.DoubleSide;
      if (c.finish !== 'Polished') { const bt = this.tex('brushfine'); zfm.bumpMap = bt; zfm.bumpScale = 0.008; zfm.roughnessMap = bt; }
      g.add(new THREE.Mesh(new THREE.LatheGeometry(zp, 160), zfm));
    }
    g.add(new THREE.Mesh(geo, bandMat));
    for (const inl of inlays) {
      const ip = []; const M = 24;
      for (let i = 0; i <= M; i++) { const y = inl.y - inl.half + (i / M) * inl.half * 2; ip.push(new THREE.Vector2(outerR(y) + 0.035, y)); }
      const matName = inl.mat || c.inlay;
      let im;
      if (METAL_INLAYS[matName]) { im = this.mat({ ...METAL_INLAYS[matName] }); const bt = this.tex('brushfine'); im.bumpMap = bt; im.bumpScale = 0.008; im.roughnessMap = bt; }
      else im = this.mat({ tex: INLAY_TEX[matName], rough: matName === 'Muonionalusta Meteorite' ? 0.3 : /Opal|Cosmos|Resin|Abalone/.test(matName) ? 0.22 : 0.55 });
      g.add(new THREE.Mesh(new THREE.LatheGeometry(ip, 160), im));
      for (const yy of [inl.y - inl.half, inl.y + inl.half]) {
        const rp = [new THREE.Vector2(outerR(yy) + 0.04, yy - 0.03), new THREE.Vector2(outerR(yy) + 0.04, yy + 0.03)];
        g.add(new THREE.Mesh(new THREE.LatheGeometry(rp, 160), new THREE.MeshPhysicalMaterial({ color: 0x111111, metalness: 0.8, roughness: 0.4, side: THREE.DoubleSide })));
      }
    }
    if (!mdef.organic && (c.groove === 'Twin grooves' || c.groove === 'Offset groove') && (c.grooveInside || c.grooveOutside)) {
      const ZR = { 'Fine brushed matt': 0.5, 'Polished': 0.1, 'Coarse brushed': 0.68, 'Faceted': 0.48, 'Sandblasted matte': 0.85, 'Hammered': 0.5 };
      const zgh = gh + 0.06;
      let zones;
      if (c.groove === 'Twin grooves') {
        const g1 = grooves[0].y, g2 = grooves[1].y;
        zones = [
          { a: g1 + zgh, b: g2 - zgh, f: c.grooveInside, col: c.grooveInsideHex },
          { a: faceLo + 0.05, b: g1 - zgh, f: c.grooveOutside, col: c.grooveOutsideHex },
          { a: g2 + zgh, b: faceHi - 0.05, f: c.grooveOutside, col: c.grooveOutsideHex, flip: true },
        ];
      } else {
        const gy = grooves[0].y;
        zones = gy >= 0 ? [
          { a: gy + zgh, b: faceHi - 0.05, f: c.grooveInside, col: c.grooveInsideHex },
          { a: faceLo + 0.05, b: gy - zgh, f: c.grooveOutside, col: c.grooveOutsideHex },
        ] : [
          { a: faceLo + 0.05, b: gy - zgh, f: c.grooveInside, col: c.grooveInsideHex },
          { a: gy + zgh, b: faceHi - 0.05, f: c.grooveOutside, col: c.grooveOutsideHex },
        ];
      }
      for (const z of zones) {
        const r = ZR[z.f];
        if (r == null || z.b - z.a < 0.2) continue;
        let zsegs = [[z.a, z.b]];
        for (const inl of inlays) {
          const nxt = [];
          for (const [sa, sb] of zsegs) {
            const ca = inl.y - inl.half - 0.05, cb = inl.y + inl.half + 0.05;
            if (cb <= sa || ca >= sb) { nxt.push([sa, sb]); continue; }
            if (ca - sa >= 0.2) nxt.push([sa, ca]);
            if (sb - cb >= 0.2) nxt.push([cb, sb]);
          }
          zsegs = nxt;
        }
        if (!zsegs.length) continue;
        const zcol = z.col ? new THREE.Color(z.col).getHex() : mdef.color;
        const zld = liftDark(zcol);
        const zc2 = zld.color, zenv = zld.env || 1.2;
        let zm;
        if (z.f === 'Faceted') {
          const inside = !z.flip && zones.indexOf(z) === 0;
          let ft = inside ? this.tex('facetrelief2') : this.tex('facetrelief');
          if (z.flip) {
            if (!this.textures.facetrelief_flip) { const f2 = ft.clone(); f2.repeat.set(ft.repeat.x, -1); f2.needsUpdate = true; this.textures.facetrelief_flip = f2; }
            ft = this.textures.facetrelief_flip;
          }
          zm = new THREE.MeshPhysicalMaterial({ map: ft, color: zc2, metalness: 0.5, roughness: zld.env ? 0.38 : 0.48, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else if (z.f === 'Coarse brushed') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('roughrelief'), color: zc2, metalness: 0.55, roughness: zld.env ? 0.5 : 0.6, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else if (z.f === 'Sandblasted matte') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('sandrelief'), color: zc2, metalness: 0.25, roughness: zld.env ? 0.72 : 0.85, envMapIntensity: zld.env ? 1.1 : 0.6, side: THREE.DoubleSide });
        } else if (z.f === 'Hammered') {
          zm = new THREE.MeshPhysicalMaterial({ map: this.tex('hammerrelief'), color: zc2, metalness: 0.5, roughness: zld.env ? 0.4 : 0.5, envMapIntensity: zenv, side: THREE.DoubleSide });
        } else {
          zm = this.mat({ ...mdef, color: zcol, rough: r });
          if (r > 0.45) { const bt = this.tex('brushfine'); zm.bumpMap = bt; zm.bumpScale = 0.008; zm.roughnessMap = bt; zm.roughness = Math.min(1, r + 0.3); }
        }
        for (const [sa, sb] of zsegs) {
          const zp = []; const M = 16;
          for (let i = 0; i <= M; i++) { const y = sa + (i / M) * (sb - sa); zp.push(new THREE.Vector2(outerR(y) + 0.025, y)); }
          g.add(new THREE.Mesh(new THREE.LatheGeometry(zp, 160), zm));
        }
      }
    }
    if (c.pinstripe) {
      const ph = (c.pinW || 0.5) / 2;
      let py = 0, pa = null, pb = null;
      if (inlays.length) {
        const inl = inlays[0];
        if (c.pinBeside) {
          const towardEdge = inl.y >= 0 ? 1 : -1;
          if (c.pinSide === 'Narrow side') {
            pa = towardEdge > 0 ? inl.y + inl.half : faceLo;
            pb = towardEdge > 0 ? faceHi : inl.y - inl.half;
          } else if (c.pinSide === 'Either side') {
            for (const sd of [-1, 1]) {
              const yy = Math.max(faceLo + ph + 0.15, Math.min(faceHi - ph - 0.15, inl.y + sd * (inl.half + ph + 0.1)));
              const p2 = this.mat({ color: c.pinColourHex ? new THREE.Color(c.pinColourHex).getHex() : mdef.color, rough: c.pinFinish === 'Brushed' ? 0.45 : 0.1 });
              if (c.pinFinish === 'Brushed') { const bt = this.tex('brushfine'); p2.bumpMap = bt; p2.bumpScale = 0.008; }
              const sp2 = [new THREE.Vector2(outerR(yy) + 0.05, yy - ph), new THREE.Vector2(outerR(yy) + 0.05, yy + ph)];
              g.add(new THREE.Mesh(new THREE.LatheGeometry(sp2, 160), p2));
            }
            pa = pb = undefined; py = null;
          } else {
            let side;
            if (c.pinSide === 'Above the inlay') side = 1;
            else if (c.pinSide === 'Below the inlay') side = -1;
            else side = -towardEdge;
            py = Math.max(faceLo + ph + 0.15, Math.min(faceHi - ph - 0.15, inl.y + side * (inl.half + ph + 0.1)));
          }
        } else py = inl.y;
      }
      if (py !== null) {
        const pmat = this.mat({ color: c.pinColourHex ? new THREE.Color(c.pinColourHex).getHex() : mdef.color, rough: c.pinFinish === 'Brushed' ? 0.45 : 0.1 });
        if (c.pinFinish === 'Brushed') { const bt = this.tex('brushfine'); pmat.bumpMap = bt; pmat.bumpScale = 0.008; }
        const [ya, yb] = pa != null ? [pa, pb] : [py - ph, py + ph];
        const pp = []; const PM = 10;
        for (let i = 0; i <= PM; i++) { const y = ya + (i / PM) * (yb - ya); pp.push(new THREE.Vector2(outerR(y) + 0.05, y)); }
        g.add(new THREE.Mesh(new THREE.LatheGeometry(pp, 160), pmat));
      }
    }
    if (c.sleeve && SLEEVES[c.sleeve]) {
      const sp = [new THREE.Vector2(R - 0.03, -hw + 0.08), new THREE.Vector2(R - 0.03, hw - 0.08)];
      g.add(new THREE.Mesh(new THREE.LatheGeometry(sp, 160), this.mat(SLEEVES[c.sleeve])));
    } else if (mdef.organic) {
      const op = [new THREE.Vector2(R - 0.015, -hw + 0.06), new THREE.Vector2(R - 0.015, hw - 0.06)];
      g.add(new THREE.Mesh(new THREE.LatheGeometry(op, 160), this.mat({ tex: mdef.tex, color: 0xffffff, rough: mdef.rough, side: THREE.DoubleSide })));
    } else {
      const boreCol = c.sleeveHex ? new THREE.Color(c.sleeveHex).getHex() : mdef.color;
      const colHexStr = '#' + new THREE.Color(boreCol).getHexString();
      const lum = (parseInt(colHexStr.slice(1, 3), 16) * 0.299 + parseInt(colHexStr.slice(3, 5), 16) * 0.587 + parseInt(colHexStr.slice(5, 7), 16) * 0.114);
      const eKey = colHexStr + '|' + w;
      if (!this._engraveKey || this._engraveKey !== eKey) {
        const cv = document.createElement('canvas'); cv.width = 2048; cv.height = 256;
        const t = new THREE.CanvasTexture(cv);
        t.wrapS = t.wrapT = THREE.RepeatWrapping; t.colorSpace = THREE.SRGBColorSpace;
        const wm = new Image();
        wm.onload = () => {
          const cx = cv.getContext('2d');
          cx.fillStyle = colHexStr; cx.fillRect(0, 0, cv.width, cv.height);
          const lh = cv.height * (1.5 / w), lw = lh * (wm.width / wm.height) * ((w / cv.height) / ((2 * Math.PI * R) / cv.width));
          cx.save();
          if (lum > 90) { cx.filter = 'invert(1)'; cx.globalAlpha = 0.55; }
          else { cx.globalAlpha = 0.7; }
          cx.translate(cv.width / 2, 0); cx.scale(-1, 1); cx.translate(-cv.width / 2, 0);
          cx.drawImage(wm, (cv.width - lw) / 2, (cv.height - lh) / 2, lw, lh);
          cx.restore();
          t.needsUpdate = true;
        };
        wm.crossOrigin = 'anonymous'; wm.src = A('assets/foundoria-wordmark.png');
        if (this._engraveTex) this._engraveTex.dispose();
        this._engraveTex = t; this._engraveKey = eKey;
      }
      const ep = [new THREE.Vector2(R - 0.015, -hw + 0.06), new THREE.Vector2(R - 0.015, hw - 0.06)];
      const em = new THREE.MeshPhysicalMaterial({ map: this._engraveTex, color: 0xffffff, metalness: 0.75, roughness: c.sleeveHex ? 0.12 : 0.35, envMapIntensity: c.sleeveHex ? 1.6 : 1.0, side: THREE.DoubleSide });
      g.add(new THREE.Mesh(new THREE.LatheGeometry(ep, 160), em));
    }
    if (!mdef.organic && (c.edge === 'Polished edge contrast' || c.zircEdges || c.bevelHex)) {
      const edgeMat = c.bevelHex ? this.mat({ color: new THREE.Color(c.bevelHex).getHex(), rough: 0.08 }) : c.zircEdges ? this.mat({ color: RAWZ, rough: 0.3 }) : this.mat({ ...mdef, rough: 0.06 });
      edgeMat.side = THREE.DoubleSide;
      const bw = Math.max(0.9, Math.max(bevel, step) + 0.01);
      const edgeR = (y) => {
        if (bevel) {
          if (y < faceLo) return outerR(faceLo) - bevel * 0.55 * ((faceLo - y) / bevel);
          if (y > faceHi) return outerR(faceHi) - bevel * 0.55 * ((y - faceHi) / bevel);
        } else if (step) {
          if (y < faceLo || y > faceHi) return outerR(y < faceLo ? faceLo : faceHi) - 0.35;
        }
        return outerR(y);
      };
      for (const [a, b] of [[-hw, -hw + bw], [hw - bw, hw]]) {
        const ep = []; const M = 10;
        for (let i = 0; i <= M; i++) { const y = a + (i / M) * (b - a); ep.push(new THREE.Vector2(edgeR(y) + 0.03, y)); }
        g.add(new THREE.Mesh(new THREE.LatheGeometry(ep, 160), edgeMat));
      }
      if (c.bevelHex || c.zircEdges) {
        for (const yy of [-hw, hw]) {
          const off = yy < 0 ? -0.015 : 0.015;
          const sp = [new THREE.Vector2(R + 0.02, yy + off), new THREE.Vector2(edgeR(yy) + 0.02, yy + off)];
          g.add(new THREE.Mesh(new THREE.LatheGeometry(sp, 160), edgeMat));
        }
      }
    }
  }
}
customElements.define('ring-viewer', RingViewer);
